import React from "react";
import "./Contact.css";
import Agenda from "../../Components/Agenda";
//import heroImage from "../../images/hero-sobre-nos.jpg"; 

const Contact = () => {

    return (
        <div id="contatos">
            {/* Imagem de fundo 
            <section
                id="hero-contatos"
                style={{ backgroundImage: `url(${heroImage})` }}
            >
            </section>
            */}

            {/* Texto inicial da página */}
            <h1>Contatos</h1>
            <p>Estamos à disposição para agendar sua consulta</p>

            {/* Conteúdo da página */}
            <section id="conteudo-contatos">
                <Agenda />
            </section>
        </div>
    )
}

export default Contact;